import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { Project } from 'routes/BudgetModule/shared/useGetProjects';
import { Box } from '@mui/material';

const StyProjects = styled(Box, {
    name: 'StyProject',
})({
    flexWrap: 'wrap',
    alignItems: 'center',
});

type ProjectsChipProps = {
    assignedProjects: Project[];
    canEdit: boolean;
    removeProjectFromInscription: (project: Project) => void;
};

const ProjectChipsDisplay = (props: ProjectsChipProps) => {
    const { assignedProjects, canEdit, removeProjectFromInscription } = props;

    const [firstProject, ...restProjects] = assignedProjects;
    const otherProjects = restProjects.length > 0 ? restProjects : undefined;
    const firstChipSize = otherProjects ? 130 : 160;

    return (
        <>
            <StyProjects>
                {firstProject && (
                    <Tooltip title={firstProject.name}>
                        <Chip
                            sx={{ maxWidth: firstChipSize }}
                            size="small"
                            label={firstProject.name}
                            onDelete={
                                canEdit
                                    ? () => {
                                          removeProjectFromInscription(
                                              firstProject,
                                          );
                                      }
                                    : undefined
                            }
                        />
                    </Tooltip>
                )}
                {otherProjects && (
                    <Tooltip
                        title={
                            <>
                                {otherProjects.map((project) => (
                                    <div key={`${project.name}+${project.id}`}>
                                        {project.name}
                                    </div>
                                ))}
                            </>
                        }
                    >
                        <Chip
                            sx={{ maxWidth: 160 }}
                            size="small"
                            label={`+${otherProjects.length}`}
                        />
                    </Tooltip>
                )}
            </StyProjects>
        </>
    );
};

export default ProjectChipsDisplay;
